export const FETCH_SCHEMES_PLAN_OPTION_REQUEST = "FETCH_SCHEMES_PLAN_OPTION_REQUEST";
export const FETCH_SCHEMES_PLAN_OPTION_SUCCESS = "FETCH_SCHEMES_PLAN_OPTION_SUCCESS";
export const FETCH_SCHEMES_PLAN_OPTION_FAILURE = "FETCH_SCHEMES_PLAN_OPTION_FAILURE";
